
import logoOxxoRetail from '@assets/logos/oxxo-retail-logo.png'
import logoOxxoRetailSmall from '@assets/logos/oxxo-retail-logo-small.png'
import { ClientConfigInfo, FILTER_TYPES, METADADATA_LOAD, SurveyResponsesTab } from './configCommons'
import { DASHBOARDS, DASHBOARDS_CONFIGS } from '../dashboard/dashboardCommons'
import { commonFilterCriticalMoments } from '../dashboard/dashHelper'
import deafultHelpDefinition from '../help/defaultHelp'
import { omoikaneHonda } from '../omoikane/omoikaneHonda'



const getMetricas = (): CriticalMoment => {
    return {
        id: -29,
        parentId: "29",
        name: "Metricas",
        code: "Metricas",
        description: "Oxxo - Metricas",
        searchOrder: 9,
        children: [],
        childrenAlias: []
    }
}

export const getOxxoRetailFilterCriticalMoments = (filtersData: Record<string, any>, userProfiles: UserProfile[], selectType: String): CriticalMoment[] => {
    /*
    const filtersDataCopy = {
        ...filtersData,
        criticalMoments: [{
            ...filtersData.criticalMoments[0],
            children: filtersData.criticalMoments[0].children.filter((c:any) => c.id != 60551),
        }], 
    }
        */

    //const commonFiltersConfg = commonFilterCriticalMoments(filtersDataCopy, userProfiles, selectType)
    const commonFiltersConfg = commonFilterCriticalMoments(filtersData, userProfiles, selectType)
    //console.log('retornando filtros de HA')
    //console.log(commonFiltersConfg)
    
    console.log("ENVIROMMENT -> "+ process.env.REACT_APP_ENVIRONMENT )

    return [
        ...commonFiltersConfg,
        //getMetricas(),
    ]
};

export const oxxoRetailConfigs: ClientConfigInfo = {
    //TODO: mejorar esta selection de ambiente por defecto es QA por ahi seria mejor que las url este ne env, el lugar de aca
    vocBackendUrl:  process.env.REACT_APP_ENVIRONMENT === 'PROD' ? 'https://oxxo-retail-backend-voc.clientship.com/api/' : 'https://oxxo-retail-backend-voc.qa.clientship.com/api/' ,
    //vocBackendUrl: 'http://localhost:9000/api/',
    lcmBackendUrl: process.env.REACT_APP_ENVIRONMENT === 'PROD' ? 'https://oxxo-retail-backend-core.clientship.com/api/ui/' : 'https://oxxo-retail-backend-core.qa.clientship.com/api/ui/',
    //caseBackendUrl: process.env.REACT_APP_ENVIRONMENT === 'PROD' ? 'https://oxxo-retail-backend-case.clientship.com/api/ui/' : 'https://oxxo-retail-backend-case.qa.clientship.com/api/ui/',
    publicUrl: '/voc',
    logoSmall: logoOxxoRetailSmall,
    logo: logoOxxoRetail,
    filtersFromDateSubstract: 1,
    filtersToDateSubstract: 0,
    decimals: undefined,
    supportsInternationalization: false,
    filters: [
        FILTER_TYPES.DATES,
        FILTER_TYPES.GEOS,
        FILTER_TYPES.CRITICAL_MOMENTS,
        FILTER_TYPES.DYNAMIC,
        FILTER_TYPES.TIME_BAND
    ],
    // Agrupa la pregunta NPS (questionId 13703) en Promotores/Neutros/Detractores
    // en vez de mostrar los 11 valores crudos (0-10) como opciones del dynamic filter.
    dynamicFilterGroups: [
        { questionId: 13703, formula: 'nps-10' }
    ],
    menuDashboards: [
        DASHBOARDS.DEFAULT, 
        DASHBOARDS.OXXO_METAS
    ],//, DASHBOARDS.OXXO_EXT],
    sentimentCommentsIndicatorName: 'SENTIMENT_COMMENTS',
    getFilterCriticalMoments: getOxxoRetailFilterCriticalMoments,
    //getFilterCriticalMomentDefault: getFilterCriticalMomentDefault,
    dateFromParamName: 'dateFrom',
    dateToParamName: 'dateTo',
    msExcelReportExt: 'xls',
    useFlatGeoLocations: true,
    useKeyPressGeoLocations: false,
    geosRootId: 29,
    logicalsRootId: 0,
    criticalMomentsRootId: 29,
    criticalMomentFilterType: 'select',
    // El root (29) también tiene su propio NPS/dynamic filters — mostrarlos sin
    // obligar a seleccionar un critical moment hijo.
    showDynamicFiltersOnCriticalMomentsRoot: true,
    actionPlans: {
        geoLeafLevel: '',
        useWorstTags: true
    },
    omoikane: omoikaneHonda,
    useBackDashboards: false,
    metadata: [
        METADADATA_LOAD.GEOS,
        METADADATA_LOAD.CRITICAL_MOMENTS,
        METADADATA_LOAD.DYNAMIC_REPORT_FIELDS
    ],
    useSentimentCategories: true,
    dashboards: {
        ...DASHBOARDS_CONFIGS.oxxoretail,
        default: DASHBOARDS_CONFIGS.oxxoretail[DASHBOARDS.DEFAULT],
    },
    staticDashboards: {},
    useDashboardDynamicPosition: true,
    surveyResponses: {
        url: 'survey-responses',
        type: 'post-context',
        tableColumns: undefined,
        tabs: [SurveyResponsesTab.ANSWERED],
        surveyDetailFields: [
            {
                position: 1,
                label: 'Área comentario',
                getValue: data => {
                    //console.log('custom field área!!!!!!!!!!')
                    //console.log(data)
                    const sentAnalysis = data
                    ?.questionResponses
                    ?.filter((q: any) => q.questionId === 999)
                    ?.map((q: any) => q.categories)
                    ?.flat(1)
                    ?.filter((item: any, index: any, arr: any) => arr.indexOf(item) === index)
                    //console.log(sentAnalysis)
                    return sentAnalysis?.map((sa: any) => sa === 'DEFAULT' ? 'Otros' : sa)?.join(' | ')
                }
            }
        ],
    },
    alerts: {
    },
    help: deafultHelpDefinition,
    pageSize: 100,
    assistantConfig: {
        enable: true,
        buttonText: "💬",
        tenant: "oxxoretail"
    }
}
